import { useState, useEffect } from "react";

/**
 * Returns whether the browser tab is currently visible.
 * Uses the Page Visibility API (document.visibilityState).
 */
export const usePageVisibility = (): boolean => {
  const [isVisible, setIsVisible] = useState(() =>
    typeof document !== "undefined"
      ? document.visibilityState === "visible"
      : true,
  );

  useEffect(() => {
    if (typeof document === "undefined") return;
    const handler = () => {
      setIsVisible(document.visibilityState === "visible");
    };
    document.addEventListener("visibilitychange", handler);
    return () => document.removeEventListener("visibilitychange", handler);
  }, []);

  return isVisible;
};
